import { CartGetItem } from 'src/types';
import { AMAZON_MAX_PARAMS_PER_CHUNK } from './amazonChunkUtils';

type Args = {
  cartStore: string;
  cartItems: CartGetItem[];
  cartReferrer?: string;
  tagParam: string | null;
  loggerUrl: string;
  chunkEnabled: boolean;
  sourceParam: string;
};

export const sendCartToAmazon = ({
  cartStore,
  cartItems,
  cartReferrer,
  tagParam,
  loggerUrl,
  chunkEnabled,
  sourceParam,
}: Args): { cartUrl?: string; cartChunks?: string[] } => {
  const itemAddParamsList: string[] = [];

  for (let i = 0, j = 1; i < cartItems.length; i++) {
    // TODO - functionality of selecting items on a per vendor basis is not supported at the moment
    // if ((handleSplitNewVendor || handleSplitOriginalVendor) && (!cartItems[i].selected === true)) {
    //   continue;
    // }
    const counter = Math.floor(cartItems[i].quantity / 10);
    const remainder = cartItems[i].quantity % 10;

    if (counter === 0) {
      itemAddParamsList.push(
        `ASIN.${j}=${cartItems[i].asin}&Quantity.${j}=${cartItems[i].quantity}&`,
      );
      j += 1;
    } else {
      for (let q = 1; q <= counter; q++) {
        itemAddParamsList.push(
          `ASIN.${j}=${cartItems[i].asin}&Quantity.${j}=10&`,
        );
        j = j + 1;
      }

      if (remainder !== 0) {
        itemAddParamsList.push(
          `ASIN.${j}=${cartItems[i].asin}&Quantity.${j}=${remainder}&`,
        );
        j = j + 1;
      }
    }
  }

  if (chunkEnabled && itemAddParamsList.length > AMAZON_MAX_PARAMS_PER_CHUNK) {
    const chunks: string[] = []; // these will be the finalized strings for the URL to add cart items to
    let currentChunk = '';
    let currentChunkQty = 0;

    // Build the chunks, capping the currentChunkQty at 25 and pushing the currentChunk to the chunks array.
    itemAddParamsList.forEach((item) => {
      // shouldn't ever be greater than, but just in case
      if (currentChunkQty >= AMAZON_MAX_PARAMS_PER_CHUNK) {
        chunks.push(
          buildUrl(
            loggerUrl,
            cartStore,
            currentChunk,
            cartReferrer || '',
            tagParam || '',
            sourceParam,
          ),
        );
        currentChunk = '';
        currentChunkQty = 0;
      }

      currentChunk += item;
      currentChunkQty++;
    });

    // cleanup if anything is left over
    if (currentChunk !== '') {
      chunks.push(
        buildUrl(
          loggerUrl,
          cartStore,
          currentChunk,
          cartReferrer || '',
          tagParam || '',
          sourceParam,
        ),
      );
    }

    return { cartChunks: chunks };
  }

  const cartUrl = buildUrl(
    loggerUrl,
    cartStore,
    itemAddParamsList.join(''),
    cartReferrer || '',
    tagParam || '',
    sourceParam,
  );

  return { cartUrl };
};

const buildUrl = (
  loggerUrl: string,
  cartStore: string,
  params: string,
  cartReferrer: string,
  tagParam: string,
  sourceParam: string,
) => {
  let cartUrl = '';
  cartUrl = `${cartStore}/gp/aws/cart/add.html?${params}`;

  if (cartReferrer) {
    cartUrl += `&AssociateTag=${cartReferrer}&tag=${cartReferrer}`;
  }

  if (tagParam) {
    cartUrl += `&AssociateTag=${tagParam}&tag=${tagParam}`;
  }

  return `${loggerUrl}${encodeURIComponent(cartUrl)}/${sourceParam}`;
};
